import React from 'react';
import { Row, Col } from 'reactstrap';

export const DatePickerLayout = ({ 
  label, 
  selectedStartDate, 
  setSelectedStartDate, 
  containerClassName = "",
  imgSrc = "",
}) => {
    const now = new Date();
    return (
        <div className={`no-spinner number-input-container ${containerClassName}`}>
        <Row className="align-items-center">
            <Col xs={6} sm={8}>
            {imgSrc && (<img className="checkout-icon" src={imgSrc} alt="icon" />)}
            <label className="ad_120_bold pl-2 number-input-text">
                {label}
            </label>
            </Col>
            <Col xs={6} sm={4} className="text-right">
            <input
                type="date"
                className="form-control"
                value={selectedStartDate}
                onChange={(e) => setSelectedStartDate(e.target.value)}
                min={now.toISOString().split('T')[0]}
            />
            </Col>
        </Row>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Order/DatePicker.js